// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-date-editor--date .el-input__prefix{display:none}.el-date-editor--date input{padding-left:0!important}.el-date-editor--date .el-input__suffix .el-input__suffix-inner .el-input__icon:before{display:none}", ""]);
// Exports
module.exports = exports;
